import React from 'react';
import Button from 'components/Button';

import Modal from 'antd/lib/modal/Modal';
import DF from 'DisplayFramework';
import MarketingLabelDetail from './MarketingLabel';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { Card } from 'antd';

type marketingLabelModalprops = {
  onCancel: () => void;
  visible: boolean;
  onSuccess?: () => void;
  idOrCreate: string;
  ParMarketingLabel: any;
  ParMarketingResponse: any;
  list?: any;
};

const MarketingLabelModal = ({
  visible,
  onCancel,
  onSuccess,
  idOrCreate,
  ParMarketingLabel,
  ParMarketingResponse,
  list,
}: marketingLabelModalprops) => {
  return (
    <DF.Provider pagcode="mcLabeldetail">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1600}
        title={<GetLabel label="Modal Label Detail" />}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <Card>
          <MarketingLabelDetail
            ParMarketingLabel={ParMarketingLabel}
            ParMarketingResponse={ParMarketingResponse}
            idOrCreate={idOrCreate}
            visible={visible}
            onSave={() => {
              onSuccess && onSuccess();
              onCancel();
            }}
            list={list}
          />
        </Card>
      </Modal>
    </DF.Provider>
  );
};

export default MarketingLabelModal;
